import { useMemo } from 'react';
import { LuMapPin, LuBriefcase } from 'react-icons/lu';
import { darkenHex } from './utils.js';
import { formatJobLocation } from 'src/_shared/services/formatJobLocation.js';

function stripHtml(html) {
	return (html || '').replace(/<[^>]*>/g, '');
}

function JobCard({ match, applied, accentColor, onInterested }) {
	const job = match.job;
	if (!job) return null;

	const location = job.location;
	const locationStr =
		typeof location === 'object' && location
			? formatJobLocation(location)
			: typeof location === 'string'
				? location
				: '';

	const departmentName = job.department?.name;
	const plainDescription = useMemo(
		() => stripHtml(job.description || ''),
		[job.description]
	);

	return (
		<div
			className="group flex flex-col rounded-2xl bg-white"
			style={{
				border: '1px solid #f1f5f9',
				padding: 18,
				minHeight: 220,
				transition:
					'transform 0.3s ease-out, box-shadow 0.3s ease-out, border-color 0.3s ease-out',
				cursor: 'default',
			}}
			onMouseOver={(e) => {
				e.currentTarget.style.boxShadow =
					'0 20px 25px -5px rgba(0,0,0,0.05), 0 8px 10px -6px rgba(0,0,0,0.05)';
				e.currentTarget.style.borderColor = '#e2e8f0';
				e.currentTarget.style.transform = 'translateY(-2px)';
			}}
			onMouseOut={(e) => {
				e.currentTarget.style.boxShadow = 'none';
				e.currentTarget.style.borderColor = '#f1f5f9';
				e.currentTarget.style.transform = 'translateY(0)';
			}}
		>
			<h3
				style={{
					fontSize: 15,
					fontWeight: 600,
					color: '#1e293b',
					margin: 0,
					marginBottom: 6,
					lineHeight: 1.3,
					display: '-webkit-box',
					WebkitLineClamp: 2,
					WebkitBoxOrient: 'vertical',
					overflow: 'hidden',
				}}
			>
				{job.title}
			</h3>

			<div
				className="flex flex-wrap items-center gap-3"
				style={{ fontSize: 12, color: '#475569', marginBottom: 10 }}
			>
				{locationStr && (
					<span className="flex items-center gap-1">
						<LuMapPin size={11} />
						{locationStr}
					</span>
				)}
				{departmentName && (
					<span className="flex items-center gap-1">
						<LuBriefcase size={11} />
						{departmentName}
					</span>
				)}
			</div>

			{plainDescription && (
				<p
					style={{
						fontSize: 13,
						color: '#475569',
						lineHeight: 1.5,
						margin: 0,
						display: '-webkit-box',
						WebkitLineClamp: 3,
						WebkitBoxOrient: 'vertical',
						overflow: 'hidden',
					}}
				>
					{plainDescription}
				</p>
			)}

			<div className="flex-1" style={{ minHeight: 14 }} />

			{applied ? (
				<button
					type="button"
					disabled
					className="w-full"
					style={{
						padding: '10px 14px',
						borderRadius: '0.75rem',
						background: '#f1f5f9',
						color: '#22c55e',
						border: 'none',
						fontWeight: 600,
						fontSize: 13,
						cursor: 'default',
					}}
				>
					You've Applied!
				</button>
			) : (
				<button
					type="button"
					onClick={() => onInterested?.(match)}
					className="w-full"
					style={{
						padding: '10px 14px',
						borderRadius: '0.75rem',
						background: accentColor,
						color: '#fff',
						border: 'none',
						fontWeight: 600,
						fontSize: 13,
						cursor: 'pointer',
						transition: 'background 0.2s',
					}}
					onMouseOver={(e) => {
						e.currentTarget.style.background = darkenHex(accentColor);
					}}
					onMouseOut={(e) => {
						e.currentTarget.style.background = accentColor;
					}}
				>
					I'm Interested
				</button>
			)}
		</div>
	);
}

export default JobCard;
